import React from 'react';
import { Modal, Card, CardContent, CardHeader, IconButton } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../components-core/data-grid/DataGridToolbar';
import { BooleanColumn } from '../../../services/column-definitions';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const OrdersModal = ({ open, handleClose, idList, setIdList, ordersDataForMessages }) => {

  const columns = [
    { field: 'identifier', headerName: 'Numer zamówienia', align: 'center', flex: 1 },
    { field: 'guardian_name', headerName: 'Opiekun', align: 'center', flex: 1 },
    { field: 'participant_name', headerName: 'Uczestnik', align: 'center', flex: 1 },
    { field: 'phone', headerName: 'Telefon', align: 'center', flex: 1 },
    { field: 'email', headerName: 'E-mail', align: 'center', flex: 1 },
    { field: 'camp', headerName: 'Turnus', align: 'center', flex: 1 },
    { field: 'return_of_agreement', headerName: 'Zwrot umowy', flex: 1, align: 'center', renderCell: params => <BooleanColumn params={params} /> },
    { field: 'event', headerName: 'Impreza', align: 'center', flex: 1 }
  ];

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style, width: '75vw', height: '80vh', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          title="Lista zamówień do który zostanie wysłana wiadomość"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
          sx={{ textAlign: 'center' }}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <DataGridPro
            rows={ordersDataForMessages}
            columns={columns}
            disableColumnMenu={true}
            autoPageSize={false}
            rowsPerPageOptions={[10, 25, 50, 100]}
            pagination
            components={{
              Toolbar: DataGridToolbar
            }}
            checkboxSelection
            onSelectionModelChange={newSelectionModel => {
              setIdList(newSelectionModel);
            }}
            selectionModel={idList}
            localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          />
        </CardContent>
      </Card>
    </Modal>
  );
};

export default OrdersModal;
